/**
 * PlottingInterface constants
 */

import { PlotVariable, PlotConfiguration } from '../types';

// TIME components that should be available for plotting
export const TIME_COMPONENT_NAMES = [
  'Y_sin', 'Y_cos',   // Yearly components
  'M_sin', 'M_cos',   // Monthly components
  'W_sin', 'W_cos',   // Weekly components
  'D_sin', 'D_cos',   // Daily components
  'Holiday'           // Holiday indicator
] as const;

// Default plot configuration
export const DEFAULT_PLOT_CONFIG: Omit<PlotConfiguration, 'inputVariables' | 'outputVariables' | 'forecastVariables' | 'timeComponents'> = {
  num_sbpl: 12,                    // Default number of subplots
  x_sbpl: 'UTC',                   // Default x-axis
  y_sbpl_fmt: 'original',          // Default y-axis format
  y_sbpl_set: 'separate Achsen'    // Default y-axis configuration
};

/**
 * Convert array of PlotVariables to a dictionary for API calls
 */
export const convertVariablesToDict = (variables: PlotVariable[]): Record<string, boolean> => {
  return variables.reduce((acc, variable) => {
    acc[variable.name] = variable.selected;
    return acc;
  }, {} as Record<string, boolean>);
};

/**
 * Create initial plot configuration
 */
export const createInitialPlotConfig = (
  inputVariables: string[],
  outputVariables: string[],
  timeComponentNames: readonly string[]
): PlotConfiguration => ({
  ...DEFAULT_PLOT_CONFIG,
  inputVariables: inputVariables.map(name => ({ name, selected: false })),
  outputVariables: outputVariables.map(name => ({ name, selected: false })),
  forecastVariables: outputVariables.map(name => ({ name, selected: false })),
  timeComponents: timeComponentNames.map(name => ({ name, selected: false }))
});
